import React from "react";
import { useParams } from "react-router-dom";

import config from "../../../config/config";

import "./AnalyticalMethods.scss";

const CKDAnalyticalMethods2026 = () => {
  const { year } = useParams();

  const download = (refNum) => {
    const url = `${config.baseUri}/analyticalMethods?year=${year}&fileName=${refNum}&volumeNumber=1`;
    window.location = url;
  };

  if (process.env.REACT_APP_BUILD === "production")
  {
    return ("This chapter is currently not available")
  }
  
  return (
    <div>
      <h1>Supplemental Methods</h1>
      <ul>
        <li>
          <button onClick={() => download("Data Sources for the CKD Volume")}>
            Data Sources for the CKD Volume
          </button>
        </li>
        <li>
          <button
            onClick={() =>
              download("Codes_for_Hospitalization_Causes_-_CKD_Volume_2025")
            }
          >
            Codes for Hospitalization Causes – CKD Volume
          </button>
        </li>
        <li>
          <button
            onClick={() =>
              download("Codes_and_Algorithm_for_Common_CVDs_2025")
            }
          >
            Codes and Algorithm for CVD and Procedure
          </button>
        </li>
        <li>
          <button onClick={() => download("Codes_for_Comorbidity_and_CKD_2025")}>
            Codes for Comorbidity and CKD
          </button>
        </li>
        <li>
          <button onClick={() => download("Codes_for_Comorbidity_and_Kidney_Disorders_in_Children_2025")}>
            Codes for Comorbidity and Kidney Disorders in Children
          </button>
        </li>
        <li>
          <button onClick={() => download("Codes_for_Prescription_Drug_Classes_2025")}>
            Codes for Prescription Drug Classes
          </button>
        </li>
        <li>
          <button onClick={() => download("Codes_for_Prescription_Drug_Classes_in_Children_2025")}>
            Codes for Prescription Drug Classes in Children
          </button>
        </li>
      </ul>
    </div>
  );
};

export default CKDAnalyticalMethods2026;
